import { useFullStoryPageView } from 'hooks/useFullstoryPageView';
import { useLogicCheckerBreadCrumbs } from 'hooks/useLogicCheckerBreadCrumbs';

import { Breadcrumbs } from 'components/common/Breadcrumbs/Breadcrumbs';
import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';
import { ShareInsightButton } from 'components/common/ShareInsightButton/ShareInsightButton';

import { riskConfig } from 'components/Dashboards/ExcellenceApps/riskConfig';
import { TreeProgramTopHeader } from 'components/common';
import { LogicQualityCategoriesTable } from 'components/widgets/LogicQualityCategoriesTable/LogicQualityCategoriesTable';
import { LogicQualityCheckActionsMenu } from 'components/widgets/LogicQualityCheckActionsMenu/LogicQualityCheckActionsMenu';
import { LogicQualityCheckSelectedFilters } from 'components/widgets/LogicQualityCheckSelectedFilter/LogicQualityCheckSelectedFilters';

export const LogicQualityCheckCategoryPage = () => {
    useFullStoryPageView({ pageName: riskConfig.logicQualityCheck.title });
    const { breadcrumbs } = useLogicCheckerBreadCrumbs({ displayLevel3Activities: false });
    return (
        <PageContainer>
            <HeaderWrapper>
                <TreeProgramTopHeader>
                    <ShareInsightButton title={riskConfig.logicQualityCheck.title} link={window.location.href} />
                    <LogicQualityCheckActionsMenu />
                </TreeProgramTopHeader>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={riskConfig.logicQualityCheck.title} />
                    <Breadcrumbs list={breadcrumbs} />
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <LogicQualityCheckSelectedFilters />
                <LogicQualityCategoriesTable />
            </MainContent>
        </PageContainer>
    );
};
